export default __webpack_public_path__ + "static/BCI-logo-better-cotton-initiative-405ebf473c285b9379804f781eee5beb.png";